module.exports = __webpack_public_path__ + "static/iso_6.5eeb8d5a.jpg";